/**
 * Global CSS custom properties injected into :root.
 *
 * Computed once at module load from the app theme so that CSS variables
 * (colours, breakpoints, spacing) are available throughout the stylesheet.
 * Consumed by <GlobalStyles styles={globalCss} /> in src/index.tsx.
 */
import voca from 'voca'

import {theme} from '@root/theme'

const cssColorVars = Object.entries(theme.palette.other.brandColors)
  .map((e: any) => `--color-${voca.kebabCase(e[0])}:${e[1]};`)
  .join('')

const cssBreakpointVars = Object.entries(theme.breakpoints.values)
  .map(
    ([key, value]: [string, number]) =>
      `--breakpoint-${voca.kebabCase(key)}:${value}${value > 0 ? 'px' : ''};`
  )
  .join('')

export const globalCss = `
  :root {
    ${cssColorVars}
    ${cssBreakpointVars}
    --spacing: ${theme.spacing()};
  }
  ::selection {
    color: white;
    background: ${theme.palette.primary.main};
  }
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration { display: none; }
  body {
    overflow: auto;
    --safe-area-inset-top: env(safe-area-inset-top);
    --safe-area-inset-bottom: env(safe-area-inset-bottom);
  }
  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    color: inherit;
  }
  .scroll-to-top {
    box-shadow: none !important;
    width: auto !important;
    height: auto !important;
    padding: 0;
    border-radius: 0;
    right: auto;
    left: auto;
    inset-inline-end: 40px;
    &:active {
      transform: none !important;
    }
    @media (max-width: ${theme.breakpoints.values.sm}px) {
      inset-inline-end: 17px;
      bottom: 17px;
    }
  }
`
